
export enum ProjectType {
  MODULE = 1,
  OTHER = 2
}